// Module
var code = "<div class=\"body main no-touch\"> <main-header/> <header-error/> <main-menu/> <div class=\"container bs\"> <router-view/> </div> <modal-message/> <loading/> <main-footer/> </div>";
// Exports
export default code;